<template>
  <div class='issueTracking'>
    <div class="bg">
      <div class="table-box">
        <el-table class="table" ref="dragTable" :data="dataList" v-loading="loading"
          element-loading-background="rgba(255, 255, 255, 0.8)" border width="100%" fit 
          stripe tooltip-effect="light" 
          :header-cell-style="{
            background: '#ECF2FE',
            borderColor: '#999999',
            color: '#383838',
            fontSize: '16px',
            fontWeight: 'bold',
          }" 
          :cell-style="{
            background: '#FFFFFF',
            borderColor: '#999999',
            fontSize: '15px',
            fontWeight: '400',
            color: '#383838',
          }"
          @cell-click="cellClick"
          >
          <el-table-column  width="100" align="center">
            <template #header>
              <div class="table-no-header-box">
                <!-- <el-checkbox :indeterminate="noConfig.noIndeterminate" v-model="noConfig.noSelected" @change="selectNoAllDo"></el-checkbox> -->
                <p class="table-no-header-title">NO.</p>
              </div>
            </template>
            <template #default="scope">
              <div class="table-no-box">
                <!-- @mousedown="mouseDownCheckBox" -->
                <!-- <el-checkbox v-model="scope.row.isSelected" @change="selectDelete(scope.row)"></el-checkbox> -->
                <span class="no-title">{{ scope.$index + 1 }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="author" label="Author" width="220" align="center"></el-table-column>
          <el-table-column prop="created" label="CREATED" width="260" align="center"></el-table-column>
          <el-table-column prop="title" label="TITLE" align="center">
            <template #default="scope">
              <div class="table-title">{{ scope.row.title }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="desc" label="DESC" align="center"></el-table-column>
          <el-table-column prop="tags" label="Tags" width="170" align="center"></el-table-column>
        </el-table>

        <div class="page-bg">
          <div class="page-left">共 {{ totalCount }} 项数据</div>
          <el-pagination class="page-right" background layout="prev, pager, next" :total="totalCount" :page-size="pageSie"
            :current-page="currentPage" @current-change="currentDo">
          </el-pagination>
        </div>

        <img
          class="delete-icon"
          id="divId"
          src="@/assets/delete-trial-icon.png"
          v-show="showDeleteIcon"
          @click="deleteDo"
        />
      </div>
    </div>
    <UniversalPopover :dialogVisible="showDeleteVisible" :title="deleteDialogTitle" :nomarl-confirm="false" @cancelDo="cancelDo" @comfirmDo="deletecomfirmDo" :confirm-name='btnConfig.yes' :cancel-name="btnConfig.no"></UniversalPopover>
  </div>
</template>
<script>
import {
  // getMetricList,
  deleteMetrics,
  queryResourcesList
} from "@/request/api";
import UniversalPopover from "@/components/UniversalPopover.vue"
import {
  MetricType,
  pushToNewWindowByParams
} from "@/utils/common"
import moment from "moment";
import {
  ResourceType,
} from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
export default {
  name: 'issueTracking',
  data() {
    return {
      totalCount: 0,
      allDataList: [],
      currentPage: 1,
      pageSie: 16,
      selectDeleteList: [],
      showDeleteVisible: false,
      deleteDialogTitle: "are you sure to delete ?",
      loading: false,
      metricType: MetricType.Issue,
      noConfig: {
        noIndeterminate: false,
        noSelected: false,
      },
      btnConfig: {
        yes: 'YES',
        no: 'NO'
      },
      resourceType: ResourceType.DATA,
    }
  },
  components: {
    UniversalPopover
  },
  watch: {
    $route(to, from) {
      if (to.fullPath != from.fullPath) {
        this.createData();
      }
    },
  },
  computed: {
    showDeleteIcon() {
      return this.selectDeleteList.length >= 1
    },
    dataList() {
      const list = this.allDataList.slice(
        this.pageSie * (this.currentPage - 1),
        this.pageSie * this.currentPage
      );
      return list  
    },
  },
  methods: {
    selectNoAllDo() {
      this.noConfig.noIndeterminate = false
      this.selectDeleteList = []
      if (this.noConfig.noSelected) {
        for (const model of this.allDataList) {
          model.isSelected = true
          this.selectDeleteList.push(model)
        }        
      } else {
        for (const model of this.allDataList) {
          model.isSelected = false
        }
        this.selectDeleteList = []
      }
    },
    cellClick(row, column) {
      if (column.no != 0) {
        this.rowClick(row)
      }
    },
    createData() {
      const pathName = location.pathname.split("/").pop()
      this.metricType = pathName.toLocaleLowerCase()      
      this.pageSie = screen.availHeight <= 875 ? 7 : 15;
      this.getDataList()
    },
    // mouseDownCheckBox(e) {
    //   const d = document.getElementById("divId");
    //   d.style.left = 10 + "px";
    //   d.style.top = e.pageY - 130 + "px";
    // },
    selectDelete(model) {
      if (model.isSelected) {
        this.selectDeleteList.push(model)
      } else {
        const index = this.selectDeleteList.indexOf(model)
        this.selectDeleteList.splice(index, 1)
      }
      this.noConfig.noIndeterminate = this.selectDeleteList.length > 0
      if (this.selectDeleteList.length == this.allDataList.length) {
        this.noConfig.noIndeterminate = false
        this.noConfig.noSelected = true
      } 
      if (this.selectDeleteList.length == 0) {
        this.noConfig.noSelected = false
        this.noConfig.noIndeterminate = false
      } 
    },
    rowClick(model) {
      const params = {
        id: model.id
      }
      if (this.metricType == MetricType.Issue) {
        pushToNewWindowByParams("IssueDetailPage", params)
      } else if (this.metricType == MetricType.Assertion) {
        pushToNewWindowByParams("AssertionDetailPage", params)
      } else if (this.metricType == MetricType.Warning) {
        pushToNewWindowByParams("GccWarningsDetailPage", params)
      } 
      // else if (this.metricType ==  MetricType.Lint) {
      //   pushToNewWindowByParams("LintDetailPage", params)
      // }
    },
    currentDo(index) {
      this.currentPage = index;
    },
    deleteDo() {
      this.showDeleteVisible = true;      
    },
    cancelDo() {
      this.showDeleteVisible = false;
    },
    async deletecomfirmDo() {
      this.cancelDo()
      const ids = []
      for (const model of this.selectDeleteList) {
        if (model.isSelected) {
          ids.push(model.id)
        }
      }
      await deleteMetrics(ids)
      this.selectDeleteList = []
      this.noConfig.noSelected = false
      this.noConfig.noIndeterminate = false
      this.getDataList()
    },
    async getDataList() {
      const pathName = location.pathname.split("/").pop()
      document.title = `aqua.${pathName}`
      const tagArr = this.$DataString.metricTags.filter(tag => {
        return pathName.toLocaleLowerCase() == tag.toLocaleLowerCase()
      })
      const tags = [...tagArr]
      if (pathName == 'warning') {
        tagArr.push("GCCWarning")
        tagArr.push("Lint")
      }
      this.allDataList = []
      this.selectDeleteList = []
      this.currentPage = 1
      this.totalCount = this.allDataList.length
      this.noConfig.noSelected = false
      this.noConfig.noIndeterminate = false
      this.loading = true
      console.log("tagArr == ", tagArr)
      try {
        const resourceObj = await queryResourcesList({type: this.resourceType, tags: tagArr}, false);
        const list = resourceObj.resourcesList
        console.log("resourceObj === ", resourceObj)
        this.allDataList = []
        for (const model of list) {
          const created = moment((model.creationtime?.seconds + model.creationtime?.nanos / Math.pow(10, 9)) * 1000).format("YYYY-MM-DD HH:mm:ss");

          let title = "";
          let describle = "";
          for (const map of model.annotationsMap) {
          if (map[0]?.trim().toLocaleLowerCase() == "title") {
            title = map[1];
          } else if (map[0]?.trim().toLocaleLowerCase() == "desc") {
            describle = map[1];
          } 
        }
          const item = {
            id: model.resourceid,
            author: model.owner,
            commiter: model.committer,
            created: created,
            file: model.file,
            title: title,
            desc: describle,
            tags: tags,//tagArr,
            isSelected: false
          }
          this.allDataList.push(item)
        }
        this.totalCount = this.allDataList.length
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    }
  },
  created() {
    this.createData()
  }
}
</script>
<style lang='less' scoped>
.issueTracking {
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  margin: auto;
}

.bg {
  padding: 35px 90px 10px 90px;
  background-color: #f5f5f5;
  min-width: 800px;
  max-width: 2600px;
  width: 100%;
  margin: auto;
}

.top-box {
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
}

.table-box {
  padding: 30px 55px;
  background-color: #ffffff;
  border-radius: 3px;
  position: relative;
}

.table {
  width: 100%;
  border: 1px solid #999999;
  .table-no-header-box {
    display: flex;
    align-items: center;
    .table-no-header-title {
      padding-top: 2px;
      margin-left: 10px;
    }
  }
  .table-no-box {
    display: flex;
    flex-direction: row;
    .no-title {
      font-size: 15px;
      margin-left: 15px;
    }
  }
  .table-title {
    color: #383838;
  }
}

.page-bg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px 0px 20px;
  margin-top: 20px;
  .page-left {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }
}

.delete-icon {
  position: absolute;
  cursor: pointer;
  height: 35px;
  width: 35px;
  left: 10px;
  top: 47px;
}

:deep(.el-table th) {
  user-select: initial !important;
  height: 70px !important;
}

:deep(.el-table td) {
  user-select: initial !important;
  height: 55px !important;
  cursor: pointer;
}
</style>